import { render, staticRenderFns } from "./SellerRate.vue?vue&type=template&id=8735799c&lang=pug&"
import script from "./SellerRate.vue?vue&type=script&lang=js&"
export * from "./SellerRate.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports